module.exports = __webpack_public_path__ + "static/media/Hover1.f89cd6ad.svg";